import { atom } from 'recoil';

export const setAddTreatment = atom({
    key: 'setAddTreatment', // unique ID (with respect to other atoms/selectors)
    default: [] // default value (aka initial value)
});  